import { normalizeAvaaioLanguage, } from "./avaaioLanguage";
export const AVAAIO_AUTH_COPY = {
    "en": {
        "language": "en",
        "locale": "en-US",
        "common": {
            "backLogin": "← Back to Login",
            "privacy": "Privacy Policy",
            "terms": "Terms & Conditions",
            "aiDisclaimer": "AI Disclaimer",
            "credits": "Credits",
            "support": "Support",
            "powered": "Ava is the AI assistant experience within AVAAIO™.",
            "builtOn": "Powered by American Global™ Technology",
            "copyright": "© {year} American Globalo, LLC. All rights reserved.",
            "trademark": "AVAAIO™ and American Global™ are trademarks of American Globalo, LLC. All rights reserved."
        },
        "login": {
            "welcomeTo": "Welcome To",
            "beta": "BETA",
            "meetAva": "Meet Ava",
            "generation": "Your intelligent companion, powered by the latest generation of AVAAIO intelligence.",
            "by": "Powered by American Global™ Technology",
            "accountDeleted": "⚠️ Account Deleted",
            "deletedCannotLogin": "This account has been deleted and cannot log in.",
            "reactivate": "Reactivate Account",
            "email": "Email",
            "password": "Password",
            "signingIn": "Signing In...",
            "signIn": "Sign In",
            "continueApple": "Continue with Apple",
            "deleted": "This account was deleted",
            "restoreInstantly": "You can restore your account securely by email.",
            "register": "Register",
            "forgotPassword": "Forgot Password",
            "enterCredentials": "Enter your email and password.",
            "loginFailed": "Login failed.",
            "invalidCredentials": "The email or password is incorrect.",
            "locked": "Too many login attempts. Try again later.",
            "banned": "This account has been banned.",
            "denied": "This account has been denied access.",
            "deactivated": "Your account is currently deactivated. Check your email to restore access.",
            "verifyEmail": "Please verify your email before continuing.",
            "subscriptionRequired": "A subscription is required to access Ava.",
            "blocked": "This account cannot access Ava.",
            "timedOut": "Login timed out. Please try again.",
            "invalidResponse": "The login response was invalid.",
            "networkError": "Network error. Try again.",
            "reactivationSent": "A reactivation email was sent. Check your inbox.",
            "reactivationFailed": "Account reactivation could not be started.",
            "reactivationError": "A reactivation error occurred."
        },
        "forgot": {
            "title": "Forgot Password",
            "subtitle": "Enter your email address and we will send you a reset link.",
            "emailPlaceholder": "Enter your email",
            "sendingLink": "Sending reset link...",
            "sending": "Sending...",
            "send": "Send Reset Link",
            "checkEmail": "Check your email for your reset link.",
            "unable": "Unable to send the reset email.",
            "error": "An error occurred while sending the reset email."
        },
        "reset": {
            "title": "Reset Password",
            "subtitle": "Enter your new password below.",
            "newPassword": "New Password",
            "confirmPassword": "Confirm Password",
            "passwordMismatch": "The passwords do not match.",
            "updating": "Updating...",
            "submit": "Reset Password",
            "success": "Password successfully reset. Redirecting to login...",
            "failed": "The password could not be reset.",
            "invalidToken": "The reset link is invalid or has expired.",
            "required": "The reset token and password are required.",
            "minimum": "The password must be at least 8 characters long."
        },
        "reactivate": {
            "title": "AVAAIO Account Reactivation",
            "processing": "Reactivating your account...",
            "missingToken": "The reactivation link is missing its token. Request a new reactivation email.",
            "success": "Your account has been reactivated. You can log in now.",
            "failed": "Reactivation failed. Request a new reactivation email."
        },
        "verify": {
            "verifying": "Verifying your account..."
        },
        "setupProfile": {
            "steps": [
                "Name",
                "Theme",
                "Age",
                "City"
            ],
            "nameQuestion": "What should Ava call you?",
            "themeQuestion": "Choose a theme color",
            "ageQuestion": "Select your age range",
            "cityQuestion": "What city do you live in?",
            "displayName": "Display name",
            "city": "City",
            "choose": "--Choose--",
            "back": "Back",
            "next": "Next",
            "saving": "Saving...",
            "finish": "Finish",
            "chooseColor": "Choose {color}",
            "saveFailed": "The profile could not be saved.",
            "networkError": "A network error occurred while saving the profile.",
            "colors": {
                "cyan": "cyan",
                "purple": "purple",
                "green": "green",
                "pink": "pink"
            }
        },
        "rating": {
            "community": "AVAAIO COMMUNITY",
            "title": "Rate your AVAAIO experience",
            "chooseRating": "Choose a rating from one to five stars",
            "select": "Select from 1 to 5 stars",
            "labels": [
                "",
                "Not satisfied",
                "Could be better",
                "Good",
                "Very good",
                "Excellent"
            ],
            "star": "star",
            "stars": "stars",
            "signInSaved": "Sign in to submit your saved rating.",
            "selected": "Rating selected. Press Submit Rating.",
            "thankYou": "Thank you for rating AVAAIO.",
            "signInRegister": "Sign in or register to submit your rating.",
            "savedAfterSignIn": "Your rating is saved and will be submitted after sign-in.",
            "submit": "Submit Rating",
            "submitting": "Submitting...",
            "verifiedWaitlist": "Your email is verified. You are on the AVAAIO waitlist.",
            "invalidWaitlist": "This waitlist verification link is invalid or expired.",
            "enterEmail": "Enter your email address.",
            "consentRequired": "Please agree to receive AVAAIO launch and early-access updates.",
            "closed": "The AVAAIO waitlist is now closed.",
            "requestFailed": "The waitlist request could not be completed.",
            "verifyEmail": "Check your email to verify your place on the AVAAIO waitlist.",
            "unavailable": "The waitlist service is temporarily unavailable.",
            "loadingInterest": "Loading early-access interest...",
            "personInterested": "person interested",
            "peopleInterested": "people interested",
            "launchingPrefix": "Launching",
            "average": "average",
            "rating": "rating",
            "ratings": "ratings",
            "noRatings": "No ratings submitted yet.",
            "joinLabel": "Join the verified waiting list",
            "emailAddress": "Email address",
            "preferredEmailLanguage": "Preferred email language",
            "bilingualNote": "English appears first. Your selected language appears directly underneath in AVAAIO emails.",
            "consent": "I agree to receive AVAAIO launch and early-access updates.",
            "joining": "Joining...",
            "join": "Join Waiting List"
        }
    },
    "es": {
        "language": "es",
        "locale": "es-MX",
        "common": {
            "backLogin": "← Volver al inicio de sesión",
            "privacy": "Política de privacidad",
            "terms": "Términos y condiciones",
            "aiDisclaimer": "Aviso sobre IA",
            "credits": "Créditos",
            "support": "Soporte",
            "powered": "Ava es la experiencia de asistente de IA dentro de AVAAIO™.",
            "builtOn": "Impulsado por la tecnología American Global™",
            "copyright": "© {year} American Globalo, LLC. Todos los derechos reservados.",
            "trademark": "AVAAIO™ y American Global™ son marcas de American Globalo, LLC. Todos los derechos reservados."
        },
        "login": {
            "welcomeTo": "Bienvenido a",
            "beta": "BETA",
            "meetAva": "Conoce a Ava",
            "generation": "Tu compañera inteligente, impulsada por la última generación de inteligencia AVAAIO.",
            "by": "Impulsada por la tecnología American Global™",
            "accountDeleted": "⚠️ Cuenta eliminada",
            "deletedCannotLogin": "Esta cuenta fue eliminada y no puede iniciar sesión.",
            "reactivate": "Reactivar cuenta",
            "email": "Correo electrónico",
            "password": "Contraseña",
            "signingIn": "Iniciando sesión...",
            "signIn": "Iniciar sesión",
            "continueApple": "Continuar con Apple",
            "deleted": "Esta cuenta fue eliminada",
            "restoreInstantly": "Puedes restaurar tu cuenta de forma segura por correo electrónico.",
            "register": "Registrarse",
            "forgotPassword": "Olvidé mi contraseña",
            "enterCredentials": "Introduce tu correo electrónico y contraseña.",
            "loginFailed": "No se pudo iniciar sesión.",
            "invalidCredentials": "El correo electrónico o la contraseña son incorrectos.",
            "locked": "Demasiados intentos de inicio de sesión. Inténtalo más tarde.",
            "banned": "Esta cuenta ha sido bloqueada.",
            "denied": "A esta cuenta se le ha denegado el acceso.",
            "deactivated": "Tu cuenta está desactivada. Revisa tu correo para restaurar el acceso.",
            "verifyEmail": "Verifica tu correo electrónico antes de continuar.",
            "subscriptionRequired": "Se requiere una suscripción para acceder a Ava.",
            "blocked": "Esta cuenta no puede acceder a Ava.",
            "timedOut": "El inicio de sesión agotó el tiempo de espera. Inténtalo de nuevo.",
            "invalidResponse": "La respuesta de inicio de sesión no fue válida.",
            "networkError": "Error de red. Inténtalo de nuevo.",
            "reactivationSent": "Se envió un correo de reactivación. Revisa tu bandeja de entrada.",
            "reactivationFailed": "No se pudo iniciar la reactivación de la cuenta.",
            "reactivationError": "Ocurrió un error de reactivación."
        },
        "forgot": {
            "title": "Olvidé mi contraseña",
            "subtitle": "Introduce tu correo electrónico y te enviaremos un enlace para restablecerla.",
            "emailPlaceholder": "Introduce tu correo electrónico",
            "sendingLink": "Enviando enlace...",
            "sending": "Enviando...",
            "send": "Enviar enlace",
            "checkEmail": "Revisa tu correo para abrir el enlace de restablecimiento.",
            "unable": "No se pudo enviar el correo de restablecimiento.",
            "error": "Ocurrió un error al enviar el correo de restablecimiento."
        },
        "reset": {
            "title": "Restablecer contraseña",
            "subtitle": "Introduce tu nueva contraseña.",
            "newPassword": "Nueva contraseña",
            "confirmPassword": "Confirmar contraseña",
            "passwordMismatch": "Las contraseñas no coinciden.",
            "updating": "Actualizando...",
            "submit": "Restablecer contraseña",
            "success": "Contraseña restablecida. Redirigiendo al inicio de sesión...",
            "failed": "No se pudo restablecer la contraseña.",
            "invalidToken": "El enlace de restablecimiento no es válido o ha caducado.",
            "required": "Se requieren el token y la contraseña.",
            "minimum": "La contraseña debe tener al menos 8 caracteres."
        },
        "reactivate": {
            "title": "Reactivación de cuenta AVAAIO",
            "processing": "Reactivando tu cuenta...",
            "missingToken": "El enlace no contiene un token. Solicita un nuevo correo de reactivación.",
            "success": "Tu cuenta fue reactivada. Ya puedes iniciar sesión.",
            "failed": "La reactivación falló. Solicita un nuevo correo."
        },
        "verify": {
            "verifying": "Verificando tu cuenta..."
        },
        "setupProfile": {
            "steps": [
                "Nombre",
                "Tema",
                "Edad",
                "Ciudad"
            ],
            "nameQuestion": "¿Cómo debe llamarte Ava?",
            "themeQuestion": "Elige un color de tema",
            "ageQuestion": "Selecciona tu rango de edad",
            "cityQuestion": "¿En qué ciudad vives?",
            "displayName": "Nombre para mostrar",
            "city": "Ciudad",
            "choose": "--Elegir--",
            "back": "Atrás",
            "next": "Siguiente",
            "saving": "Guardando...",
            "finish": "Finalizar",
            "chooseColor": "Elegir {color}",
            "saveFailed": "No se pudo guardar el perfil.",
            "networkError": "Ocurrió un error de red al guardar el perfil.",
            "colors": {
                "cyan": "cian",
                "purple": "morado",
                "green": "verde",
                "pink": "rosa"
            }
        },
        "rating": {
            "community": "COMUNIDAD AVAAIO",
            "title": "Califica tu experiencia con AVAAIO",
            "chooseRating": "Elige una calificación de una a cinco estrellas",
            "select": "Elige de 1 a 5 estrellas",
            "labels": [
                "",
                "Muy mala",
                "Mala",
                "Buena",
                "Muy buena",
                "Excelente"
            ],
            "star": "estrella",
            "stars": "estrellas",
            "signInSaved": "Inicia sesión para enviar tu calificación guardada.",
            "selected": "Calificación seleccionada. Pulsa Enviar calificación.",
            "thankYou": "Gracias por calificar AVAAIO.",
            "signInRegister": "Inicia sesión o regístrate para enviar tu calificación.",
            "savedAfterSignIn": "Tu calificación está guardada y se enviará después de iniciar sesión.",
            "submit": "Enviar calificación",
            "submitting": "Enviando...",
            "verifiedWaitlist": "Tu correo está verificado. Estás en la lista de espera de AVAAIO.",
            "invalidWaitlist": "Este enlace de verificación no es válido o ha caducado.",
            "enterEmail": "Introduce tu correo electrónico.",
            "consentRequired": "Acepta recibir novedades de lanzamiento y acceso anticipado de AVAAIO.",
            "closed": "La lista de espera de AVAAIO está cerrada.",
            "requestFailed": "No se pudo completar la solicitud.",
            "verifyEmail": "Revisa tu correo para verificar tu lugar en la lista de espera.",
            "unavailable": "El servicio de lista de espera no está disponible temporalmente.",
            "loadingInterest": "Cargando el interés de acceso anticipado...",
            "personInterested": "persona interesada",
            "peopleInterested": "personas interesadas",
            "launchingPrefix": "Lanzamiento",
            "average": "de promedio",
            "rating": "calificación",
            "ratings": "calificaciones",
            "noRatings": "Aún no hay calificaciones.",
            "joinLabel": "Únete a la lista de espera verificada",
            "emailAddress": "Correo electrónico",
            "preferredEmailLanguage": "Idioma preferido para correos",
            "bilingualNote": "El inglés aparece primero. El idioma seleccionado aparece directamente debajo en los correos de AVAAIO.",
            "consent": "Acepto recibir novedades de lanzamiento y acceso anticipado de AVAAIO.",
            "joining": "Uniéndose...",
            "join": "Unirse a la lista"
        }
    },
    "fr": {
        "language": "fr",
        "locale": "fr-FR",
        "common": {
            "backLogin": "← Retour à la connexion",
            "privacy": "Politique de confidentialité",
            "terms": "Conditions générales",
            "aiDisclaimer": "Avertissement sur l’IA",
            "credits": "Crédits",
            "support": "Assistance",
            "powered": "Ava est l’expérience d’assistant IA au sein d’AVAAIO™.",
            "builtOn": "Propulsé par la technologie American Global™",
            "copyright": "© {year} American Globalo, LLC. Tous droits réservés.",
            "trademark": "AVAAIO™ et American Global™ sont des marques d’American Globalo, LLC. Tous droits réservés."
        },
        "login": {
            "welcomeTo": "Bienvenue sur",
            "beta": "BÊTA",
            "meetAva": "Découvrez Ava",
            "generation": "Votre compagne intelligente, propulsée par la dernière génération de l’intelligence AVAAIO.",
            "by": "Propulsée par la technologie American Global™",
            "accountDeleted": "⚠️ Compte supprimé",
            "deletedCannotLogin": "Ce compte a été supprimé et ne peut pas se connecter.",
            "reactivate": "Réactiver le compte",
            "email": "Adresse e-mail",
            "password": "Mot de passe",
            "signingIn": "Connexion...",
            "signIn": "Se connecter",
            "continueApple": "Continuer avec Apple",
            "deleted": "Ce compte a été supprimé",
            "restoreInstantly": "Vous pouvez restaurer votre compte de manière sécurisée par e-mail.",
            "register": "S’inscrire",
            "forgotPassword": "Mot de passe oublié",
            "enterCredentials": "Saisissez votre adresse e-mail et votre mot de passe.",
            "loginFailed": "La connexion a échoué.",
            "invalidCredentials": "L’adresse e-mail ou le mot de passe est incorrect.",
            "locked": "Trop de tentatives de connexion. Réessayez plus tard.",
            "banned": "Ce compte a été bloqué.",
            "denied": "L’accès de ce compte a été refusé.",
            "deactivated": "Votre compte est désactivé. Consultez votre e-mail pour restaurer l’accès.",
            "verifyEmail": "Vérifiez votre adresse e-mail avant de continuer.",
            "subscriptionRequired": "Un abonnement est requis pour accéder à Ava.",
            "blocked": "Ce compte ne peut pas accéder à Ava.",
            "timedOut": "La connexion a expiré. Réessayez.",
            "invalidResponse": "La réponse de connexion n’était pas valide.",
            "networkError": "Erreur réseau. Réessayez.",
            "reactivationSent": "Un e-mail de réactivation a été envoyé.",
            "reactivationFailed": "La réactivation du compte n’a pas pu être lancée.",
            "reactivationError": "Une erreur de réactivation s’est produite."
        },
        "forgot": {
            "title": "Mot de passe oublié",
            "subtitle": "Saisissez votre adresse e-mail pour recevoir un lien de réinitialisation.",
            "emailPlaceholder": "Saisissez votre adresse e-mail",
            "sendingLink": "Envoi du lien...",
            "sending": "Envoi...",
            "send": "Envoyer le lien",
            "checkEmail": "Consultez votre e-mail pour ouvrir le lien de réinitialisation.",
            "unable": "Impossible d’envoyer l’e-mail de réinitialisation.",
            "error": "Une erreur s’est produite lors de l’envoi."
        },
        "reset": {
            "title": "Réinitialiser le mot de passe",
            "subtitle": "Saisissez votre nouveau mot de passe.",
            "newPassword": "Nouveau mot de passe",
            "confirmPassword": "Confirmer le mot de passe",
            "passwordMismatch": "Les mots de passe ne correspondent pas.",
            "updating": "Mise à jour...",
            "submit": "Réinitialiser",
            "success": "Mot de passe réinitialisé. Redirection vers la connexion...",
            "failed": "Le mot de passe n’a pas pu être réinitialisé.",
            "invalidToken": "Le lien de réinitialisation est invalide ou expiré.",
            "required": "Le jeton et le mot de passe sont requis.",
            "minimum": "Le mot de passe doit contenir au moins 8 caractères."
        },
        "reactivate": {
            "title": "Réactivation du compte AVAAIO",
            "processing": "Réactivation de votre compte...",
            "missingToken": "Le lien ne contient aucun jeton. Demandez un nouvel e-mail.",
            "success": "Votre compte a été réactivé. Vous pouvez vous connecter.",
            "failed": "La réactivation a échoué. Demandez un nouvel e-mail."
        },
        "verify": {
            "verifying": "Vérification de votre compte..."
        },
        "setupProfile": {
            "steps": [
                "Nom",
                "Thème",
                "Âge",
                "Ville"
            ],
            "nameQuestion": "Comment Ava doit-elle vous appeler ?",
            "themeQuestion": "Choisissez une couleur de thème",
            "ageQuestion": "Sélectionnez votre tranche d’âge",
            "cityQuestion": "Dans quelle ville vivez-vous ?",
            "displayName": "Nom affiché",
            "city": "Ville",
            "choose": "--Choisir--",
            "back": "Retour",
            "next": "Suivant",
            "saving": "Enregistrement...",
            "finish": "Terminer",
            "chooseColor": "Choisir {color}",
            "saveFailed": "Le profil n’a pas pu être enregistré.",
            "networkError": "Une erreur réseau s’est produite pendant l’enregistrement.",
            "colors": {
                "cyan": "cyan",
                "purple": "violet",
                "green": "vert",
                "pink": "rose"
            }
        },
        "rating": {
            "community": "COMMUNAUTÉ AVAAIO",
            "title": "Évaluez votre expérience AVAAIO",
            "chooseRating": "Choisissez une note de une à cinq étoiles",
            "select": "Choisissez de 1 à 5 étoiles",
            "labels": [
                "",
                "Très mauvaise",
                "Mauvaise",
                "Bonne",
                "Très bonne",
                "Excellente"
            ],
            "star": "étoile",
            "stars": "étoiles",
            "signInSaved": "Connectez-vous pour envoyer votre note enregistrée.",
            "selected": "Note sélectionnée. Appuyez sur Envoyer la note.",
            "thankYou": "Merci d’avoir évalué AVAAIO.",
            "signInRegister": "Connectez-vous ou inscrivez-vous pour envoyer votre note.",
            "savedAfterSignIn": "Votre note est enregistrée et sera envoyée après la connexion.",
            "submit": "Envoyer la note",
            "submitting": "Envoi...",
            "verifiedWaitlist": "Votre e-mail est vérifié. Vous êtes sur la liste d’attente AVAAIO.",
            "invalidWaitlist": "Ce lien de vérification est invalide ou expiré.",
            "enterEmail": "Saisissez votre adresse e-mail.",
            "consentRequired": "Acceptez de recevoir les actualités de lancement et d’accès anticipé.",
            "closed": "La liste d’attente AVAAIO est fermée.",
            "requestFailed": "La demande n’a pas pu être effectuée.",
            "verifyEmail": "Consultez votre e-mail pour confirmer votre place.",
            "unavailable": "Le service de liste d’attente est temporairement indisponible.",
            "loadingInterest": "Chargement de l’intérêt pour l’accès anticipé...",
            "personInterested": "personne intéressée",
            "peopleInterested": "personnes intéressées",
            "launchingPrefix": "Lancement",
            "average": "de moyenne",
            "rating": "note",
            "ratings": "notes",
            "noRatings": "Aucune note pour le moment.",
            "joinLabel": "Rejoignez la liste d’attente vérifiée",
            "emailAddress": "Adresse e-mail",
            "preferredEmailLanguage": "Langue préférée des e-mails",
            "bilingualNote": "L’anglais apparaît en premier. La langue sélectionnée apparaît directement en dessous dans les e-mails AVAAIO.",
            "consent": "J’accepte de recevoir les actualités de lancement et d’accès anticipé d’AVAAIO.",
            "joining": "Inscription...",
            "join": "Rejoindre la liste"
        }
    },
    "de": {
        "language": "de",
        "locale": "de-DE",
        "common": {
            "backLogin": "← Zurück zur Anmeldung",
            "privacy": "Datenschutzerklärung",
            "terms": "Allgemeine Geschäftsbedingungen",
            "aiDisclaimer": "KI-Hinweis",
            "credits": "Danksagungen",
            "support": "Support",
            "powered": "Ava ist das KI-Assistentenerlebnis innerhalb von AVAAIO™.",
            "builtOn": "Unterstützt durch American Global™ Technologie",
            "copyright": "© {year} American Globalo, LLC. Alle Rechte vorbehalten.",
            "trademark": "AVAAIO™ und American Global™ sind Marken von American Globalo, LLC. Alle Rechte vorbehalten."
        },
        "login": {
            "welcomeTo": "Willkommen bei",
            "beta": "BETA",
            "meetAva": "Lernen Sie Ava kennen",
            "generation": "Ihre intelligente Begleiterin, unterstützt von der neuesten Generation der AVAAIO-Intelligenz.",
            "by": "Unterstützt durch American Global™ Technologie",
            "accountDeleted": "⚠️ Konto gelöscht",
            "deletedCannotLogin": "Dieses Konto wurde gelöscht und kann sich nicht anmelden.",
            "reactivate": "Konto reaktivieren",
            "email": "E-Mail-Adresse",
            "password": "Passwort",
            "signingIn": "Anmeldung...",
            "signIn": "Anmelden",
            "continueApple": "Mit Apple fortfahren",
            "deleted": "Dieses Konto wurde gelöscht",
            "restoreInstantly": "Sie können Ihr Konto sicher per E-Mail wiederherstellen.",
            "register": "Registrieren",
            "forgotPassword": "Passwort vergessen",
            "enterCredentials": "Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein.",
            "loginFailed": "Die Anmeldung ist fehlgeschlagen.",
            "invalidCredentials": "E-Mail-Adresse oder Passwort ist falsch.",
            "locked": "Zu viele Anmeldeversuche. Versuchen Sie es später erneut.",
            "banned": "Dieses Konto wurde gesperrt.",
            "denied": "Diesem Konto wurde der Zugriff verweigert.",
            "deactivated": "Ihr Konto ist deaktiviert. Prüfen Sie Ihre E-Mail zur Wiederherstellung.",
            "verifyEmail": "Bestätigen Sie Ihre E-Mail-Adresse, bevor Sie fortfahren.",
            "subscriptionRequired": "Für den Zugriff auf Ava ist ein Abonnement erforderlich.",
            "blocked": "Dieses Konto kann nicht auf Ava zugreifen.",
            "timedOut": "Zeitüberschreitung bei der Anmeldung. Versuchen Sie es erneut.",
            "invalidResponse": "Die Anmeldeantwort war ungültig.",
            "networkError": "Netzwerkfehler. Versuchen Sie es erneut.",
            "reactivationSent": "Eine Reaktivierungs-E-Mail wurde gesendet.",
            "reactivationFailed": "Die Reaktivierung konnte nicht gestartet werden.",
            "reactivationError": "Bei der Reaktivierung ist ein Fehler aufgetreten."
        },
        "forgot": {
            "title": "Passwort vergessen",
            "subtitle": "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten.",
            "emailPlaceholder": "E-Mail-Adresse eingeben",
            "sendingLink": "Link wird gesendet...",
            "sending": "Wird gesendet...",
            "send": "Link senden",
            "checkEmail": "Prüfen Sie Ihre E-Mail auf den Link zum Zurücksetzen.",
            "unable": "Die E-Mail zum Zurücksetzen konnte nicht gesendet werden.",
            "error": "Beim Senden der E-Mail ist ein Fehler aufgetreten."
        },
        "reset": {
            "title": "Passwort zurücksetzen",
            "subtitle": "Geben Sie unten Ihr neues Passwort ein.",
            "newPassword": "Neues Passwort",
            "confirmPassword": "Passwort bestätigen",
            "passwordMismatch": "Die Passwörter stimmen nicht überein.",
            "updating": "Aktualisierung...",
            "submit": "Passwort zurücksetzen",
            "success": "Passwort zurückgesetzt. Weiterleitung zur Anmeldung...",
            "failed": "Das Passwort konnte nicht zurückgesetzt werden.",
            "invalidToken": "Der Link ist ungültig oder abgelaufen.",
            "required": "Token und Passwort sind erforderlich.",
            "minimum": "Das Passwort muss mindestens 8 Zeichen enthalten."
        },
        "reactivate": {
            "title": "AVAAIO-Kontoreaktivierung",
            "processing": "Ihr Konto wird reaktiviert...",
            "missingToken": "Dem Link fehlt das Token. Fordern Sie eine neue E-Mail an.",
            "success": "Ihr Konto wurde reaktiviert. Sie können sich anmelden.",
            "failed": "Die Reaktivierung ist fehlgeschlagen. Fordern Sie eine neue E-Mail an."
        },
        "verify": {
            "verifying": "Ihr Konto wird bestätigt..."
        },
        "setupProfile": {
            "steps": [
                "Name",
                "Design",
                "Alter",
                "Stadt"
            ],
            "nameQuestion": "Wie soll Ava Sie nennen?",
            "themeQuestion": "Wählen Sie eine Designfarbe",
            "ageQuestion": "Wählen Sie Ihre Altersgruppe",
            "cityQuestion": "In welcher Stadt leben Sie?",
            "displayName": "Anzeigename",
            "city": "Stadt",
            "choose": "--Auswählen--",
            "back": "Zurück",
            "next": "Weiter",
            "saving": "Speichern...",
            "finish": "Fertigstellen",
            "chooseColor": "{color} auswählen",
            "saveFailed": "Das Profil konnte nicht gespeichert werden.",
            "networkError": "Beim Speichern ist ein Netzwerkfehler aufgetreten.",
            "colors": {
                "cyan": "Cyan",
                "purple": "Violett",
                "green": "Grün",
                "pink": "Rosa"
            }
        },
        "rating": {
            "community": "AVAAIO-COMMUNITY",
            "title": "Bewerten Sie Ihre AVAAIO-Erfahrung",
            "chooseRating": "Wählen Sie eine Bewertung von einem bis fünf Sternen",
            "select": "Wählen Sie 1 bis 5 Sterne",
            "labels": [
                "",
                "Sehr schlecht",
                "Schlecht",
                "Gut",
                "Sehr gut",
                "Ausgezeichnet"
            ],
            "star": "Stern",
            "stars": "Sterne",
            "signInSaved": "Melden Sie sich an, um Ihre gespeicherte Bewertung zu senden.",
            "selected": "Bewertung ausgewählt. Drücken Sie Bewertung senden.",
            "thankYou": "Vielen Dank für Ihre AVAAIO-Bewertung.",
            "signInRegister": "Melden Sie sich an oder registrieren Sie sich.",
            "savedAfterSignIn": "Ihre Bewertung ist gespeichert und wird nach der Anmeldung gesendet.",
            "submit": "Bewertung senden",
            "submitting": "Wird gesendet...",
            "verifiedWaitlist": "Ihre E-Mail ist bestätigt. Sie stehen auf der AVAAIO-Warteliste.",
            "invalidWaitlist": "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
            "enterEmail": "Geben Sie Ihre E-Mail-Adresse ein.",
            "consentRequired": "Stimmen Sie den AVAAIO-Start- und Frühzugangsmitteilungen zu.",
            "closed": "Die AVAAIO-Warteliste ist geschlossen.",
            "requestFailed": "Die Anfrage konnte nicht abgeschlossen werden.",
            "verifyEmail": "Prüfen Sie Ihre E-Mail, um Ihren Wartelistenplatz zu bestätigen.",
            "unavailable": "Der Wartelistendienst ist vorübergehend nicht verfügbar.",
            "loadingInterest": "Interesse am Frühzugang wird geladen...",
            "personInterested": "interessierte Person",
            "peopleInterested": "interessierte Personen",
            "launchingPrefix": "Start",
            "average": "Durchschnitt",
            "rating": "Bewertung",
            "ratings": "Bewertungen",
            "noRatings": "Noch keine Bewertungen.",
            "joinLabel": "Der bestätigten Warteliste beitreten",
            "emailAddress": "E-Mail-Adresse",
            "preferredEmailLanguage": "Bevorzugte E-Mail-Sprache",
            "bilingualNote": "Englisch erscheint zuerst. Die gewählte Sprache steht in AVAAIO-E-Mails direkt darunter.",
            "consent": "Ich möchte AVAAIO-Mitteilungen zu Start und Frühzugang erhalten.",
            "joining": "Beitritt...",
            "join": "Warteliste beitreten"
        }
    },
    "it": {
        "language": "it",
        "locale": "it-IT",
        "common": {
            "backLogin": "← Torna all’accesso",
            "privacy": "Informativa sulla privacy",
            "terms": "Termini e condizioni",
            "aiDisclaimer": "Avviso sull’IA",
            "credits": "Crediti",
            "support": "Assistenza",
            "powered": "Ava è l’esperienza di assistente IA all’interno di AVAAIO™.",
            "builtOn": "Basato sulla tecnologia American Global™",
            "copyright": "© {year} American Globalo, LLC. Tutti i diritti riservati.",
            "trademark": "AVAAIO™ e American Global™ sono marchi di American Globalo, LLC. Tutti i diritti riservati."
        },
        "login": {
            "welcomeTo": "Benvenuto in",
            "beta": "BETA",
            "meetAva": "Scopri Ava",
            "generation": "La tua assistente intelligente, basata sull’ultima generazione dell’intelligenza AVAAIO.",
            "by": "Basata sulla tecnologia American Global™",
            "accountDeleted": "⚠️ Account eliminato",
            "deletedCannotLogin": "Questo account è stato eliminato e non può accedere.",
            "reactivate": "Riattiva account",
            "email": "Indirizzo email",
            "password": "Password",
            "signingIn": "Accesso...",
            "signIn": "Accedi",
            "continueApple": "Continua con Apple",
            "deleted": "Questo account è stato eliminato",
            "restoreInstantly": "Puoi ripristinare il tuo account in modo sicuro tramite email.",
            "register": "Registrati",
            "forgotPassword": "Password dimenticata",
            "enterCredentials": "Inserisci il tuo indirizzo email e la password.",
            "loginFailed": "Accesso non riuscito.",
            "invalidCredentials": "L’indirizzo email o la password non sono corretti.",
            "locked": "Troppi tentativi di accesso. Riprova più tardi.",
            "banned": "Questo account è stato bloccato.",
            "denied": "A questo account è stato negato l’accesso.",
            "deactivated": "Il tuo account è disattivato. Controlla l’email per ripristinarlo.",
            "verifyEmail": "Verifica il tuo indirizzo email prima di continuare.",
            "subscriptionRequired": "È necessario un abbonamento per accedere ad Ava.",
            "blocked": "Questo account non può accedere ad Ava.",
            "timedOut": "Tempo di accesso scaduto. Riprova.",
            "invalidResponse": "La risposta di accesso non era valida.",
            "networkError": "Errore di rete. Riprova.",
            "reactivationSent": "È stata inviata un’email di riattivazione.",
            "reactivationFailed": "Non è stato possibile avviare la riattivazione.",
            "reactivationError": "Si è verificato un errore di riattivazione."
        },
        "forgot": {
            "title": "Password dimenticata",
            "subtitle": "Inserisci il tuo indirizzo email per ricevere un collegamento di reimpostazione.",
            "emailPlaceholder": "Inserisci il tuo indirizzo email",
            "sendingLink": "Invio del collegamento...",
            "sending": "Invio...",
            "send": "Invia collegamento",
            "checkEmail": "Controlla la tua email per aprire il collegamento.",
            "unable": "Non è stato possibile inviare l’email.",
            "error": "Si è verificato un errore durante l’invio."
        },
        "reset": {
            "title": "Reimposta password",
            "subtitle": "Inserisci la nuova password.",
            "newPassword": "Nuova password",
            "confirmPassword": "Conferma password",
            "passwordMismatch": "Le password non corrispondono.",
            "updating": "Aggiornamento...",
            "submit": "Reimposta password",
            "success": "Password reimpostata. Reindirizzamento all’accesso...",
            "failed": "Non è stato possibile reimpostare la password.",
            "invalidToken": "Il collegamento non è valido o è scaduto.",
            "required": "Il token e la password sono obbligatori.",
            "minimum": "La password deve contenere almeno 8 caratteri."
        },
        "reactivate": {
            "title": "Riattivazione account AVAAIO",
            "processing": "Riattivazione dell’account...",
            "missingToken": "Il collegamento non contiene il token. Richiedi una nuova email.",
            "success": "Il tuo account è stato riattivato. Ora puoi accedere.",
            "failed": "Riattivazione non riuscita. Richiedi una nuova email."
        },
        "verify": {
            "verifying": "Verifica dell’account..."
        },
        "setupProfile": {
            "steps": [
                "Nome",
                "Tema",
                "Età",
                "Città"
            ],
            "nameQuestion": "Come deve chiamarti Ava?",
            "themeQuestion": "Scegli un colore del tema",
            "ageQuestion": "Seleziona la tua fascia d’età",
            "cityQuestion": "In quale città vivi?",
            "displayName": "Nome visualizzato",
            "city": "Città",
            "choose": "--Scegli--",
            "back": "Indietro",
            "next": "Avanti",
            "saving": "Salvataggio...",
            "finish": "Termina",
            "chooseColor": "Scegli {color}",
            "saveFailed": "Non è stato possibile salvare il profilo.",
            "networkError": "Si è verificato un errore di rete durante il salvataggio.",
            "colors": {
                "cyan": "ciano",
                "purple": "viola",
                "green": "verde",
                "pink": "rosa"
            }
        },
        "rating": {
            "community": "COMUNITÀ AVAAIO",
            "title": "Valuta la tua esperienza AVAAIO",
            "chooseRating": "Scegli una valutazione da una a cinque stelle",
            "select": "Scegli da 1 a 5 stelle",
            "labels": [
                "",
                "Pessima",
                "Scarsa",
                "Buona",
                "Molto buona",
                "Eccellente"
            ],
            "star": "stella",
            "stars": "stelle",
            "signInSaved": "Accedi per inviare la valutazione salvata.",
            "selected": "Valutazione selezionata. Premi Invia valutazione.",
            "thankYou": "Grazie per aver valutato AVAAIO.",
            "signInRegister": "Accedi o registrati per inviare la valutazione.",
            "savedAfterSignIn": "La valutazione è salvata e verrà inviata dopo l’accesso.",
            "submit": "Invia valutazione",
            "submitting": "Invio...",
            "verifiedWaitlist": "La tua email è verificata. Sei nella lista d’attesa AVAAIO.",
            "invalidWaitlist": "Questo collegamento non è valido o è scaduto.",
            "enterEmail": "Inserisci il tuo indirizzo email.",
            "consentRequired": "Accetta di ricevere aggiornamenti sul lancio e sull’accesso anticipato.",
            "closed": "La lista d’attesa AVAAIO è chiusa.",
            "requestFailed": "Non è stato possibile completare la richiesta.",
            "verifyEmail": "Controlla la tua email per verificare il posto nella lista.",
            "unavailable": "Il servizio della lista d’attesa non è temporaneamente disponibile.",
            "loadingInterest": "Caricamento dell’interesse per l’accesso anticipato...",
            "personInterested": "persona interessata",
            "peopleInterested": "persone interessate",
            "launchingPrefix": "Lancio",
            "average": "di media",
            "rating": "valutazione",
            "ratings": "valutazioni",
            "noRatings": "Nessuna valutazione ancora.",
            "joinLabel": "Unisciti alla lista d’attesa verificata",
            "emailAddress": "Indirizzo email",
            "preferredEmailLanguage": "Lingua email preferita",
            "bilingualNote": "L’inglese appare per primo. La lingua selezionata appare direttamente sotto nelle email AVAAIO.",
            "consent": "Accetto di ricevere aggiornamenti AVAAIO sul lancio e sull’accesso anticipato.",
            "joining": "Iscrizione...",
            "join": "Unisciti alla lista"
        }
    },
    "pt": {
        "language": "pt",
        "locale": "pt-BR",
        "common": {
            "backLogin": "← Voltar ao login",
            "privacy": "Política de privacidade",
            "terms": "Termos e condições",
            "aiDisclaimer": "Aviso sobre IA",
            "credits": "Créditos",
            "support": "Suporte",
            "powered": "Ava é a experiência de assistente de IA dentro do AVAAIO™.",
            "builtOn": "Desenvolvido com a tecnologia American Global™",
            "copyright": "© {year} American Globalo, LLC. Todos os direitos reservados.",
            "trademark": "AVAAIO™ e American Global™ são marcas da American Globalo, LLC. Todos os direitos reservados."
        },
        "login": {
            "welcomeTo": "Bem-vindo ao",
            "beta": "BETA",
            "meetAva": "Conheça a Ava",
            "generation": "Sua assistente inteligente, impulsionada pela mais recente geração da inteligência AVAAIO.",
            "by": "Desenvolvida com a tecnologia American Global™",
            "accountDeleted": "⚠️ Conta excluída",
            "deletedCannotLogin": "Esta conta foi excluída e não pode entrar.",
            "reactivate": "Reativar conta",
            "email": "Endereço de email",
            "password": "Senha",
            "signingIn": "Entrando...",
            "signIn": "Entrar",
            "continueApple": "Continuar com a Apple",
            "deleted": "Esta conta foi excluída",
            "restoreInstantly": "Você pode restaurar sua conta com segurança por email.",
            "register": "Cadastre-se",
            "forgotPassword": "Esqueci minha senha",
            "enterCredentials": "Digite seu endereço de email e sua senha.",
            "loginFailed": "Não foi possível entrar.",
            "invalidCredentials": "O endereço de email ou a senha está incorreto.",
            "locked": "Muitas tentativas de login. Tente novamente mais tarde.",
            "banned": "Esta conta foi bloqueada.",
            "denied": "O acesso desta conta foi negado.",
            "deactivated": "Sua conta está desativada. Verifique seu email para restaurar o acesso.",
            "verifyEmail": "Verifique seu endereço de email antes de continuar.",
            "subscriptionRequired": "É necessária uma assinatura para acessar a Ava.",
            "blocked": "Esta conta não pode acessar a Ava.",
            "timedOut": "O login atingiu o limite de tempo. Tente novamente.",
            "invalidResponse": "A resposta de login não foi válida.",
            "networkError": "Erro de rede. Tente novamente.",
            "reactivationSent": "Um email de reativação foi enviado.",
            "reactivationFailed": "Não foi possível iniciar a reativação.",
            "reactivationError": "Ocorreu um erro de reativação."
        },
        "forgot": {
            "title": "Esqueci minha senha",
            "subtitle": "Digite seu endereço de email para receber um link de redefinição.",
            "emailPlaceholder": "Digite seu endereço de email",
            "sendingLink": "Enviando link...",
            "sending": "Enviando...",
            "send": "Enviar link",
            "checkEmail": "Verifique seu email para abrir o link de redefinição.",
            "unable": "Não foi possível enviar o email de redefinição.",
            "error": "Ocorreu um erro ao enviar o email."
        },
        "reset": {
            "title": "Redefinir senha",
            "subtitle": "Digite sua nova senha.",
            "newPassword": "Nova senha",
            "confirmPassword": "Confirmar senha",
            "passwordMismatch": "As senhas não coincidem.",
            "updating": "Atualizando...",
            "submit": "Redefinir senha",
            "success": "Senha redefinida. Redirecionando para o login...",
            "failed": "Não foi possível redefinir a senha.",
            "invalidToken": "O link não é válido ou expirou.",
            "required": "O token e a senha são obrigatórios.",
            "minimum": "A senha deve ter pelo menos 8 caracteres."
        },
        "reactivate": {
            "title": "Reativação da conta AVAAIO",
            "processing": "Reativando sua conta...",
            "missingToken": "O link não contém o token. Solicite um novo email.",
            "success": "Sua conta foi reativada. Você já pode entrar.",
            "failed": "A reativação falhou. Solicite um novo email."
        },
        "verify": {
            "verifying": "Verificando sua conta..."
        },
        "setupProfile": {
            "steps": [
                "Nome",
                "Tema",
                "Idade",
                "Cidade"
            ],
            "nameQuestion": "Como a Ava deve chamar você?",
            "themeQuestion": "Escolha uma cor de tema",
            "ageQuestion": "Selecione sua faixa etária",
            "cityQuestion": "Em qual cidade você mora?",
            "displayName": "Nome de exibição",
            "city": "Cidade",
            "choose": "--Escolher--",
            "back": "Voltar",
            "next": "Avançar",
            "saving": "Salvando...",
            "finish": "Concluir",
            "chooseColor": "Escolher {color}",
            "saveFailed": "Não foi possível salvar o perfil.",
            "networkError": "Ocorreu um erro de rede ao salvar o perfil.",
            "colors": {
                "cyan": "ciano",
                "purple": "roxo",
                "green": "verde",
                "pink": "rosa"
            }
        },
        "rating": {
            "community": "COMUNIDADE AVAAIO",
            "title": "Avalie sua experiência com o AVAAIO",
            "chooseRating": "Escolha uma avaliação de uma a cinco estrelas",
            "select": "Escolha de 1 a 5 estrelas",
            "labels": [
                "",
                "Muito ruim",
                "Ruim",
                "Boa",
                "Muito boa",
                "Excelente"
            ],
            "star": "estrela",
            "stars": "estrelas",
            "signInSaved": "Entre para enviar sua avaliação salva.",
            "selected": "Avaliação selecionada. Pressione Enviar avaliação.",
            "thankYou": "Obrigado por avaliar o AVAAIO.",
            "signInRegister": "Entre ou cadastre-se para enviar sua avaliação.",
            "savedAfterSignIn": "Sua avaliação está salva e será enviada depois do login.",
            "submit": "Enviar avaliação",
            "submitting": "Enviando...",
            "verifiedWaitlist": "Seu email foi verificado. Você está na lista de espera do AVAAIO.",
            "invalidWaitlist": "Este link de verificação não é válido ou expirou.",
            "enterEmail": "Digite seu endereço de email.",
            "consentRequired": "Aceite receber atualizações de lançamento e acesso antecipado.",
            "closed": "A lista de espera do AVAAIO está fechada.",
            "requestFailed": "Não foi possível concluir a solicitação.",
            "verifyEmail": "Verifique seu email para confirmar seu lugar na lista.",
            "unavailable": "O serviço da lista de espera está temporariamente indisponível.",
            "loadingInterest": "Carregando o interesse de acesso antecipado...",
            "personInterested": "pessoa interessada",
            "peopleInterested": "pessoas interessadas",
            "launchingPrefix": "Lançamento",
            "average": "de média",
            "rating": "avaliação",
            "ratings": "avaliações",
            "noRatings": "Ainda não há avaliações.",
            "joinLabel": "Entre na lista de espera verificada",
            "emailAddress": "Endereço de email",
            "preferredEmailLanguage": "Idioma preferido dos emails",
            "bilingualNote": "O inglês aparece primeiro. O idioma selecionado aparece logo abaixo nos emails do AVAAIO.",
            "consent": "Aceito receber atualizações do AVAAIO sobre lançamento e acesso antecipado.",
            "joining": "Entrando...",
            "join": "Entrar na lista"
        }
    }
};
export function getAvaaioAuthCopy(value) {
    const language = normalizeAvaaioLanguage(value);
    return AVAAIO_AUTH_COPY[language];
}
export function interpolateAuthCopy(template, values) {
    return Object.entries(values).reduce((current, [key, value]) => current.replaceAll(`{${key}}`, String(value)), String(template || ""));
}
export function localizeAuthResponse(value, fallback, copy) {
    let raw = "";
    if (typeof value === "string") {
        raw = value;
    }
    else if (value && typeof value === "object") {
        const candidate = value;
        raw = String(candidate.message ||
            candidate.detail ||
            candidate.error ||
            candidate.code ||
            "");
    }
    const normalized = raw
        .trim()
        .toLowerCase();
    if (!normalized) {
        return fallback;
    }
    const mappings = [
        ["invalid credentials", copy.login.invalidCredentials],
        ["too many login attempts", copy.login.locked],
        ["account has been banned", copy.login.banned],
        ["account has been denied access", copy.login.denied],
        ["currently deactivated", copy.login.deactivated],
        ["verify your email", copy.login.verifyEmail],
        ["subscription required", copy.login.subscriptionRequired],
        ["cannot access ava", copy.login.blocked],
        ["reactivation email sent", copy.login.reactivationSent],
        ["check your email to reactivate", copy.login.reactivationSent],
        ["reactivation failed", copy.login.reactivationFailed],
        ["invalid or expired reset token", copy.reset.invalidToken],
        ["invalid or expired token", copy.reset.invalidToken],
        ["token and password are required", copy.reset.required],
        ["password must be at least", copy.reset.minimum],
        ["password updated successfully", copy.reset.success],
    ];
    for (const [needle, translated] of mappings) {
        if (normalized.includes(needle)) {
            return translated;
        }
    }
    return fallback;
}
